import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuditHolder } from '../models/Audits/audit-holder';
import { environment } from 'src/environments/environment';
import { ActionHolder } from '../models/Compliance-Actions/action-holder';
import { BasicResult } from '../models/basic-result';
import { ActionResponse } from '../models/Compliance-Actions/action-response';
import { Action } from '../models/Compliance-Actions/action';
import { BasicUser } from '../models/basic-user';
import { ObservableReference } from '../models/Utils/observable-reference';
import { ActionUserRequest } from '../models/Compliance-Actions/action-user-request';
import { ActionHistory } from '../models/Audits/action-history';
import { ComplianceAction } from '../models/Audits/compliance-action';
import { ActionListRequest } from '../models/Compliance-Actions/action-list-request';
import { ActionResult } from '../models/Compliance-Actions/action-result';
import { ActionFiltersResult } from '../models/Compliance-Actions/action-filters-result';
import { Observable, catchError, map, of } from 'rxjs';
import { ActionPhoto } from '../models/Compliance-Actions/action-photo';
import { ActionFile } from '../models/Compliance-Actions/action-file';
import { BasicAction } from '../models/Audits/AuditResults/basic-action';

@Injectable({
  providedIn: 'root'
})
export class ComplianceActionService {

  constructor(private httpClient: HttpClient) { }
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    observe: "response" as "response",
    responseType: "json" as const,
    withCredentials: true
  };


    httpUploadOptions = {
    withCredentials: true,
    reportProgress: true,
    observe: 'events' as 'events'
  };


  
  getCurrentActions(request:ActionListRequest): Observable<ActionResult> {
    const payload: ActionListRequest = new ActionListRequest({
      ...request,
      ActionTypeID: request?.ActionTypeID ?? 1
    });
    return this.httpClient.post<ActionResult>(`${environment.apiUrl}actions/actionlist`, payload, this.httpOptions).pipe(
      map((res:any) => {
        return new ActionResult(res.body!);
      })
    );
  }

  getPagedCurrentActions(request:ActionListRequest): Observable<ActionResult> {
    const payload: ActionListRequest = new ActionListRequest({
      ...request,
      ActionTypeID: request?.ActionTypeID ?? 1,
      PageNumber: request?.PageNumber && request.PageNumber > 0 ? request.PageNumber : 1,
      PageSize: request?.PageSize && request.PageSize > 0 ? request.PageSize : 100
    });
    return this.httpClient.post<ActionResult>(`${environment.apiUrl}actionsv2/actionlist`, payload, this.httpOptions).pipe(
      map((res:any) => {
        return new ActionResult(res.body!);
      }),
      catchError(() => this.getCurrentActions(payload))
    );
  }

  updateAction(actionResponse: ActionResponse): Observable<BasicResult> {
    return this.httpClient.post<ActionResponse>(`${environment.apiUrl}actions/updateaction`, new ActionResponse(actionResponse), this.httpOptions).pipe(
      map((res:any) => {
        return new BasicResult(res.body!);
      })
    );
  }
  
  modifyAction(modifiedAction: Action): Observable<BasicResult>{
    return this.httpClient.post<Action>(`${environment.apiUrl}actions/modifyaction`, new Action(modifiedAction), this.httpOptions).pipe(
      map((res:any) => {
        return new BasicResult(res.body!);
      })
    );
  }
  saveNewAction(newAction:ComplianceAction):Observable<BasicResult>{
     return this.httpClient.post<ComplianceAction>(`${environment.apiUrl}actions/newaction`, new Action(newAction), this.httpOptions).pipe(
      map((res:any) => {
        return new BasicResult(res.body!);
      })
    );
  }
  saveEventAction(newAction:ComplianceAction):Observable<BasicResult>{
    const payload = new Action({
      ...newAction,
      ActionTypeID: newAction?.ActionTypeID && newAction.ActionTypeID > 0 ? newAction.ActionTypeID : 2
    });
    return this.httpClient.post<ComplianceAction>(`${environment.apiUrl}actions/neweventaction`, payload, this.httpOptions).pipe(
      map((res:any) => {
        return new BasicResult(res.body!);
      })
    );
  }
  getActionUsers(AUR: ActionUserRequest): Observable<BasicUser[]>{
    return this.httpClient.post<BasicUser[]>(`${environment.apiUrl}actions/actionusers`, AUR, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  getEventActionUsers(AUR: ActionUserRequest): Observable<BasicUser[]>{
    return this.httpClient.post<BasicUser[]>(`${environment.apiUrl}actions/actionusers`, AUR, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  getActionHistory(auditID:number):Observable<ActionHistory[]>{
    return this.httpClient.post<ActionHistory[]>(`${environment.apiUrl}actions/getactionhistory`, auditID, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  getActionByID(actionID:number):Observable<Action>{
    return this.httpClient.post<Action>(`${environment.apiUrl}actions/getactiondetail`, actionID, this.httpOptions).pipe(
      map((res:any) => {
        const body = res?.body ?? res;
        const mapped = {
          ...body,
          AuditCompletedDate: body?.AuditCompletedDate ? new Date(body.AuditCompletedDate) : undefined
        };
        return new Action(mapped);
      })
    );
  }

  getEligibleAuditsForAction(actionId: number): Observable<any[]>{
    return this.httpClient.get<any[]>(`${environment.apiUrl}actions/${actionId}/eligibleaudits`, this.httpOptions).pipe(
      map((res:any) => res?.body ?? res ?? [])
    );
  }

  attachAuditToAction(actionId: number, auditResultId: number): Observable<BasicResult>{
    const payload = { ActionID: actionId, AuditResultID: auditResultId };
    return this.httpClient.post<BasicResult>(`${environment.apiUrl}actions/attachaudit`, payload, this.httpOptions).pipe(
      map((res:any) => res?.body ?? res)
    );
  }
  getActionFilters():Observable<ActionFiltersResult>{
     return this.httpClient.get<ActionFiltersResult>(`${environment.apiUrl}actions/actionfilters`,this.httpOptions).pipe(
      map((res:any) => {
        return new ActionFiltersResult(res.body!);
      })
    );
  }
  uploadActionPhoto(photoHolder:ActionPhoto){
        return this.httpClient.post<BasicResult>(`${environment.apiUrl}actions/saveactionphoto`,photoHolder,this.httpOptions);
  }
  getActionPhotos(actionID:number){
    return this.httpClient.post<string[]>(`${environment.apiUrl}actions/getphotos`,actionID,this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  uploadActionFile(fileHolder:ActionFile){
      var uploadData:FormData = new FormData();
      uploadData.append("FileData",fileHolder.FileData);
      uploadData.append("ActionID",fileHolder.ActionID.toString());
      

        return this.httpClient.post<BasicResult>(`${environment.apiUrl}actions/saveactionfile`,uploadData,this.httpUploadOptions);
  }
  getActionFiles(actionID:number){

    return this.httpClient.post<string[]>(`${environment.apiUrl}actions/getfiles`,actionID,this.httpOptions);
  }
  downloadActionFile(guid: string){
    return this.httpClient.get(`${environment.apiUrl}actions/getattachment/${guid}`, {
      observe: 'response',
      responseType: 'blob',
      withCredentials: true
    });
  }
  downloadActionPhoto(guid: string){
    return this.httpClient.get(`${environment.apiUrl}actions/getphoto/${guid}`, {
      observe: 'response',
      responseType: 'blob',
      withCredentials: true
    });
  }

  getEventActions(EventID:number, childrenOnly:boolean = false, parentActionID:number = -1, actionTypeID:number = 2, auditResultDetailID:number = -1, includeAuditActions:boolean = false): Observable<BasicAction[]>{
    const req = { EventID, ChildrenOnly: childrenOnly, ParentActionID: parentActionID, ActionTypeID: actionTypeID, AuditResultDetailID: auditResultDetailID, IncludeAuditActions: includeAuditActions };
    return this.httpClient.post<ActionResult>(`${environment.apiUrl}actions/eventactions`, req, this.httpOptions).pipe(
      map((res:any) => {
        const body = res.body ? res.body : res;
        if (body?.IsError){
          return [] as BasicAction[];
        }
        return (body?.Actions || []).map((a:any) => {
          const mapped = {
            ...a,
            AssignedTo: a.ActionAssignee ?? a.AssignedTo ?? '',
            AuditResultDetailID: a.AuditResultDetailID ?? a.ReferenceID ?? -1,
            ActionTypeID: a.ActionTypeID ?? 1,
            AuditName: a.AuditName ?? '',
            ActionVariationID: a.ActionVariationID ?? 1,
            AuditID: a.AuditID ?? null,
            AuditResultID: a.AuditResultID && a.AuditResultID > 0 ? a.AuditResultID : null,
            EventName: a.EventName ?? '',
            EventLocationName: a.EventLocationName ?? a.LocationName ?? '',
            WorkflowActionTitle: a.WorkflowActionTitle ?? '',
            WorkflowName: a.WorkflowName ?? '',
            RequiredAuditID: a.RequiredAuditID ?? null,
            RequiredAuditName: a.RequiredAuditName ?? '',
            SourceType: a.SourceType ?? '',
            Mandatory: a.Mandatory ?? a.IsMandatory ?? null,
            ActionDeadline: a.ActionDeadline ? new Date(a.ActionDeadline) : undefined,
            ResolvedDate: a.ResolvedDate ? new Date(a.ResolvedDate) : undefined
          };
          return new BasicAction(mapped);
        });
      })
    );
  }

}
